<!--
  Card Component
  Surface container with optional header and padding options.
-->
<script lang="ts">
  export let padding: 'none' | 'sm' | 'md' | 'lg' = 'md';

  const paddingClasses: Record<string, string> = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-5',
  };
</script>

<div class="bg-surface border border-border rounded-lg {paddingClasses[padding]}">
  {#if $$slots.header}
    <div class="pb-3 mb-3 border-b border-border">
      <slot name="header" />
    </div>
  {/if}

  <slot />
</div>
